import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[OnlyDecimal]',
	standalone: false,
})
export class OnlyDecimalDirective {
	private validDecimal: RegExp = /^(?!.*e).*\d(\.(\d{1,2})?)?$/;
	private validKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

	constructor(private el: ElementRef) {}
	/** Checks for valid decimal input but prevents normal behavior if we detect paste, that will be handled in the paste @HotListener onPaste handler */
	@HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
		if (this.validKeys.includes(event.key)) {
			return true;
		}

		const inputVal: string = this.el.nativeElement.value.concat(event.key);
		if (inputVal && !String(inputVal).match(this.validDecimal)) {
			// ctrl v is handled in the onPaste function below
			if (event.ctrlKey && event.key === 'v') {
				return true;
			}
			if (this.el.nativeElement.value === '' && inputVal !== 'e' && inputVal !== 'E') {
				return true;
			}
			// invalid characters will be prevented with preventDefault()
			event.preventDefault();
			return false;
		}

		return true;
	}

	@HostListener('paste', ['$event']) onPaste(event) {
		if (event instanceof ClipboardEvent) {
			const clipboardData = event.clipboardData.getData('text/plain');
			if (clipboardData) {
				if (!this.validDecimal.test(clipboardData)) {
					event.preventDefault();
				}
			}
		}
	}
}
